<template>
  <div>
    <v-sheet
      v-if="!loading && noneDisplayProduct"
      class="pa-4">
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="7"
          lg="7"
          xl="7"
          class="align-left">
          <p class="text-h6">
            เวลาที่นับ : {{ noneDisplayProduct.createdAt | dateTimeUserFormat }}
          </p>
          <p class="text-base">
            นับโดย : {{ noneDisplayProduct.createdBy.email }}
          </p>
          <p class="text-base">
            สาขา : {{ noneDisplayProduct.warehouse.name }}
          </p>
          <p class="text-base">
            Collection : {{ noneDisplayProduct.collection ? noneDisplayProduct.collection.name : '-' }}
          </p>
          <p
            v-if="noneDisplayProduct.isEmptyStock && noneDisplayProduct.collection"
            class="text-h6 success--text">
            ไม่มีรายการสินค้า collection {{ noneDisplayProduct.collection.name }} ในสต๊อก
          </p>
          <p
            v-else-if="noneDisplayProduct.isEmptyStock"
            class="text-h6 success--text">
            ไม่มีรายการสินค้าในสต๊อก
          </p>
          <p
            v-else-if="!noneDisplayProduct.hasNoDisplay"
            class="text-h6 success--text">
            สินค้าทุกรายการถูกวางโชว์แล้ว
          </p>
        </v-col>
        <v-col
          v-if="noneDisplayProduct.hasNoDisplay"
          id="exclude-ui"
          class="flex text-right"
          cols="12"
          sm="12"
          md="5"
          lg="5"
          xl="5">
          <v-btn
            v-if="filterProducts.length && !$vuetify.breakpoint.xsOnly"
            class="white--text mr-4"
            color="indigo"
            @click="printTable">
            PRINT
          </v-btn>
          <v-btn
            v-if="filterProducts.length"

            color="success"
            @click="exportCSV()">
            EXPORT
          </v-btn>
        </v-col>
        <v-col
          v-if="noneDisplayProduct.hasNoDisplay"
          id="exclude-ui"
          class="d-flex text-right justify-center align-center"
          cols="12"
          md="5"
          offset-md="7">
          <v-autocomplete
            v-model="collection"
            :items="collections"
            item-text="name"
            item-value="id"
            class="mr-2"
            label="Collection"
            color="secondary"
            outlined
            dense
            hide-details
            clearable
            :loading="loadingAttribute" />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            hide-details
            outlined
            dense></v-text-field>
        </v-col>
        <v-col
          v-if="!loading && noneDisplayProduct.hasNoDisplay"
          class="print-none-display"
          cols="12">
          <v-tabs
            v-model="tab"
            background-color="dark"
            dark
          >
            <v-tab
              v-for="(item, index) in tabs"
              :key="`tab-${index}`"
            >
              {{ item }}
            </v-tab>
          </v-tabs>
          <v-card
            v-for="(product, index) in filterProducts"
            :key="index"
            elevation="1"
            class="mb-4 pa-4 table-wrapper">
            <v-simple-table>
              <tbody>
                <tr>
                  <td width="25%">
                    <img
                      width="60px"
                      :src="product.photoUrl ? `${product.photoUrl[0]}?fm=jpg&q=95&fit=crop&w=60&auto=compresss` : noPicture"
                      alt="" />
                  </td>
                  <td colspan="2">
                    <p>{{ product.name }}</p>
                    <p>{{ product.model }}</p>
                    <p>Collection : {{ product.collection || '-' }}</p>
                  </td>
                  <td class="text-right">
                    <p
                      v-if="product.noOneSkuShow "
                      class="mb-0 text-h6 red--text">
                      ไม่มีวางโชว์
                    </p>
                    <p
                      v-else
                      class="mb-0 text-h6 indigo--text">
                      โชว์บางไซส์
                    </p>
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold">
                    Code
                  </td>
                  <td
                    width="30%"
                    class="font-weight-bold">
                    สี - ไซส์
                  </td>
                  <td class="font-weight-bold text-right">
                    สต๊อก
                  </td>
                  <td class="font-weight-bold text-right">
                    วางโชว์
                  </td>
                </tr>
                <tr
                  v-for="(sku, sindex) in product.skus"
                  :key="`sku-${sindex}`"
                  :class="sku.display > 0 ? 'green-light-bg' : ''">
                  <td width="20%">
                    {{ sku.code }}
                  </td>
                  <td width="30%">
                    {{ sku.color }} - {{ sku.size }}
                  </td>
                  <td
                    width="25%"
                    class="text-right">
                    {{ sku.stock | showNumberFormat() }}
                  </td>
                  <td
                    width="25%"
                    class="text-right">
                    {{ sku.display | showNumberFormat() }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
import RFIDProvider from '@/resources/RFIDProvider'
import axios from 'axios'
import NoPicture from '@/assets/image/no_picture_available.png'
import { ExportToCsv } from 'export-to-csv'
import SizeValues from '@/assets/js/SizeValues'
import ProductCollectionProvider from '@/resources/ProductCollectionProvider'

export default {
  components: {},
  data () {
    return {
      search: '',
      products: [],
      rfidProvider: new RFIDProvider(),
      productCollectionProvider: new ProductCollectionProvider(),
      loading: false,
      noneDisplayProduct: null,
      noPicture: NoPicture,
      tab: 0,
      tabs: [
        'ทั้งหมด',
        'โชว์บางไซส์',
        'ไม่มีวางโชว์'
      ],
      collection: null,
      collections: [],
      loadingAttribute: true
    }
  },
  computed: {
    filterProducts () {
      const lowerSearch = this.search?.toLowerCase() || ''

      let filtered = this.products

      if (this.search) {
        filtered = this.products.filter((product) => product.name.toLowerCase().includes(lowerSearch)
            || product.model === this.search
            || (product.skus && product.skus.some((sku) => sku.code.toLowerCase().includes(lowerSearch))))
      }
      filtered = filtered.filter((product) => this.tab === 0
        || (this.tab === 1 && product.noOneSkuShow === false)
        || (this.tab === 2 && product.noOneSkuShow === true))

      if (this.collection) {
        filtered = filtered.filter((product) => product.collectionId === this.collection)
      }
      return filtered.sort((a, b) => b.noOneSkuShow - a.noOneSkuShow)
    }
  },
  async mounted () {
    await this.getAttributes()
    await this.fetchById()
  },
  methods: {
    sortSize (skus) {
      return skus.sort((a, b) => SizeValues(a.size) - SizeValues(b.size))
    },
    async getAttributes () {
      this.loadingAttribute = true
      try {
        const { data: collections } = await this.productCollectionProvider.getAll({
          page: 1,
          limit: 999,
          sortBy: 'createdAt',
          sortOrder: 'desc'
        })
        this.collections = collections.results
      } catch (error) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error.message || error,
          type: 'error'
        })
      } finally {
        this.loadingAttribute = false
      }
    },
    async fetchById () {
      this.loading = true
      try {
        const { data } = await this.rfidProvider.getById(this.$route.params.id)
        if (data) {
          this.noneDisplayProduct = data
          const productData = await axios.get(data.resultDocument)
          this.products = productData.data
          this.products = productData.data.map((product) => ({
              ...product,
              skus: this.sortSize(product.skus)
            }))
        }
      } catch (error) {
        console.error('fetch by id', error)
      } finally {
        this.loading = false
      }
    },
    formatDataForDownload () {
      return this.filterProducts.flatMap((
        { photoUrl, collection, productId, skus, hasNoDisplay, noOneSkuShow, ...productWithoutPhoto }
      ) => skus.map((sku) => ({
        ...productWithoutPhoto,
        collection: collection || '',
        ...sku
      })))
    },
    async exportCSV () {
      try {
        this.exporting = true
        const exportValue = this.formatDataForDownload()
        const countDate = this.$dayjs(this.noneDisplayProduct.createdAt).format('DD_MM_YYYY')
        const options = {
          filename: `none_display_${countDate}`,
          showLabels: true,
          useKeysAsHeaders: true
        }

        const csvExporter = new ExportToCsv(options)
        csvExporter.generateCsv(exportValue)
      } catch (error) {
        console.error('exportCsv', error)
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: error?.message || error,
          type: 'error'
        })
      } finally {
        this.exporting = false
      }
    },
    printTable () {
      const originalTitle = document.title
      const countDate = this.$dayjs(this.noneDisplayProduct.createdAt).format('DD_MM_YYYY')
      document.title = `none_display_${countDate}`
      window.print()
      setTimeout(() => {
        document.title = originalTitle
      }, 1000)
    }
  }
}
</script>

<style>
.green-light-bg {
  background-color: #ebfff0;
}
@media print {
  .table-wrapper {
    height: auto !important;
    border: 1;
    overflow-y: visible;
  }
  #sidebar {
    display: none !important;
  }

  #exclude-ui {
    display: none !important;
  }

  .v-sheet.theme--light.v-toolbar.v-toolbar--dense.v-app-bar.v-app-bar--fixed {
    display: none !important;
  }

  .print-none-display {
    width: 100% !important;
    page-break-after: always;
    page-break-before: always;
    clear: both;
    margin-bottom: 4;
  }
  #app main.v-main {
    padding: 0 !important;
  }
}
</style>
